<template functional>
  <svg :fill="props.fill" class="icon icon--success" :class="props.classes" xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 50 50">
    <circle class="icon--success__circle" cx="25" cy="25" r="24" fill="none" stroke-width="2" stroke-miterlimit="10"/>
    <path  class="icon--success__tick"  fill="none" stroke-width="2" stroke-linecap="round" stroke-miterlimit="10" d="M35 20L20.58 34.24l-7.55-7.12"/>
  </svg>
</template>

<script>
export default {
  name: 'IconSuccess',
  props: {
    fill: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    }
  }
}
</script>
